import { render, staticRenderFns } from "./CourseAdd.vue?vue&type=template&id=4900c384&scoped=true"
import script from "./CourseAdd.vue?vue&type=script&lang=js"
export * from "./CourseAdd.vue?vue&type=script&lang=js"
import style0 from "./CourseAdd.vue?vue&type=style&index=0&id=4900c384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900c384",
  null
  
)

export default component.exports